import { useRouter } from "found";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Found and React Router do not detect changes in the url when the other router causes a change;
// instead we must manually sync the two routers
// DevNote: Remove on completion of migration to React Router
export const FoundAndReactRouterSync = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { match, router } = useRouter();

  const windowUrl = window.location.pathname + window.location.search + window.location.hash;
  const reactRouterUrl = location.pathname + location.search + location.hash;
  const foundUrl = match.location.pathname + match.location.search + match.location.hash;

  useEffect(() => {
    if (windowUrl !== reactRouterUrl) {
      navigate(windowUrl, { replace: true });
    } else if (windowUrl !== foundUrl) {
      router.push(windowUrl);
    }
  }, [windowUrl, reactRouterUrl, foundUrl]);

  return null;
};
